module.exports = __webpack_public_path__ + "static/media/Hotel-Sensoria.345dc204.png";